import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import colors from 'styles/colors'

const Seo = ({ title, description, metaImage, previewImage, children }) => (
  <Helmet
    htmlAttributes={{
      lang: 'en',
    }}
    title={title}
    meta={[
      {
        name: `description`,
        content: description,
      },
      {
        name: `keywords`,
        content:
          'flip fit, flip, Sephora, ulta, beauty, skincare, flip app, Flip beauty',
      },
      {
        property: `og:title`,
        content: title,
      },
      {
        property: `og:description`,
        content: description,
      },
      {
        property: `og:type`,
        content: description,
      },
      {
        property: `og:image`,
        content: metaImage,
      },
      {
        name: `twitter:card`,
        content: description,
      },
      {
        name: `twitter:creator`,
        content: 'Flip Fit LTD',
      },
      {
        name: `twitter:title`,
        content: title,
      },
      {
        name: `twitter:description`,
        content: description,
      },
      {
        name: `twitter:image`,
        content: previewImage,
      },
      {
        name: `thumbnail`,
        content: previewImage,
      },
    ]}
  >
    {/*inline style elements*/}
    <style type="text/css">
      {`
      body {
  margin: 0;
  font-family: 'Montserrat', -apple-system, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #131313;
  background-color: ${colors.grayLightBg};
}
      `}
    </style>
    <script type="application/ld+json">
      {`{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "name": "${title}",
        "url": "https://company.flip.shop/",
        "description": "${description}",
        "image": "${previewImage}"
      }`}
    </script>
    {children}
  </Helmet>
)

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  metaImage: PropTypes.string,
  previewImage: PropTypes.string,
}

Seo.defaultProps = {
  title: `Flip: Beauty Shopping. Reinvented.`,
  description:
    'Tune in to 100s of Live Shopping Show, on skincare, beauty, fashion and more. Free shipping and returns. Next day shipping on all orders. Fulfilled by Flip',
  metaImage: 'https://d1fdwmzorj1z8t.cloudfront.net/flip_og_image.png',
  previewImage:
    'https://d1fdwmzorj1z8t.cloudfront.net/flip-logo-box-square.png',
}

export default Seo
